import { render, staticRenderFns } from "./InputSwitch.global.vue?vue&type=template&id=665cdc54&scoped=true&lang=pug&"
import script from "./InputSwitch.global.vue?vue&type=script&lang=ts&"
export * from "./InputSwitch.global.vue?vue&type=script&lang=ts&"
import style0 from "./InputSwitch.global.vue?vue&type=style&index=0&id=665cdc54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665cdc54",
  null
  
)

export default component.exports